import axios from 'axios';

const client = axios.create({
  baseURL: 'https://get.geojs.io/v1',
  withCredentials: false
});

const API = {
  IP: {
    reveal: () => client.get('/ip.json')
  },
  Country: {
    reveal: () => client.get('/ip/country.json')
  },
  reveal: () => client.get('/ip/geo.json')
};

window.geo = API;

export default API;
